<div class="audit-log-view">
  <div class="header-row">
    <div>
      <h2>Audit Log</h2>
      <p>Track template and scholarship changes for accountability and review.</p>
    </div>
    <button type="button" class="btn btn-secondary" (click)="refresh()">
      <i class="fas fa-sync-alt"></i> Refresh
    </button>
  </div>

  @if (revertMessage) {
    <div class="alert alert-success">
      <i class="fas fa-check-circle"></i> {{ revertMessage }}
    </div>
  }

  <div class="card filters-card">
    <div class="card-body">
      <div class="filters-row">
        <div>
          <label>Search</label>
          <input type="text" class="form-control" [(ngModel)]="searchQuery" (ngModelChange)="onFiltersChanged()"
            placeholder="Template, scholarship, action, country...">
        </div>
        <div>
          <label>Action</label>
          <select class="form-control" [(ngModel)]="filterAction" (ngModelChange)="onFiltersChanged()">
            <option value="">All actions</option>
            @for (action of actionOptions; track action) {
              <option [value]="action">{{ action }}</option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">Activity Entries <span class="count-pill">{{ filteredLogs.length }}</span></div>
    <div class="card-body no-padding">
      <div class="table-wrap">
        <table class="table audit-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Action</th>
              <th>Entity</th>
              <th>Details</th>
              <!-- <th>Revert</th> -->
            </tr>
          </thead>
          <tbody>
            @if (filteredLogs.length === 0) {
              <tr>
                <td colspan="5" class="empty-cell">No audit records found.</td>
              </tr>
            }
            @for (log of paginatedLogs; track log) {
              <tr>
                <td>{{ log.timestamp | date: 'dd MMM yyyy HH:mm' }}</td>
                <td>
                  <span class="badge" [ngClass]="getActionClass(log.action)">{{ log.action }}</span>
                </td>
                <td>{{ log.entityName }}</td>
                <td>
                  @if (getChangeSummary(log.changes); as changes) {
                    <ul class="change-summary">
                      @for (change of changes; track change) {
                        <li>
                          <strong>{{ change.field }}</strong>
                          <ul>
                            <li><span>Old:</span> {{ change.oldValue }}</li>
                            <li><span>New:</span> {{ change.newValue }}</li>
                          </ul>
                        </li>
                      }
                      @if (changes.length === 0) {
                        <li class="no-changes">—</li>
                      }
                    </ul>
                  }
                </td>
                <!-- <td>
                <button *ngIf="hasSnapshot(log)" type="button" class="btn btn-secondary btn-sm"
                  (click)="requestRevert(log)" title="Revert to this version">
                  <i class="fas fa-undo"></i> Revert
                </button>
                <span *ngIf="!hasSnapshot(log)" style="color:#ccc; font-size:12px;">—</span>
              </td> -->
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="filteredLogs.length"
      [showingFrom]="showingFrom" [showingTo]="showingTo" itemLabel="entries"
    (pageChange)="goToPage($event)"></app-pagination>
  </div>
</div>
</div>

<!-- Revert Confirmation Modal -->
<!-- <div class="modal-overlay" *ngIf="showRevertConfirm" (click)="cancelRevert()">
<div class="confirm-modal" (click)="$event.stopPropagation()">
  <div class="confirm-icon"><i class="fas fa-undo"></i></div>
  <h3>Revert to Previous Version?</h3>
  <p>
    This will restore <strong>{{ logToRevert.entityName }}</strong> to the state it was in
    before the <strong>{{ logToRevert.action }}</strong> on
    {{ logToRevert.timestamp | date: 'dd MMM yyyy HH:mm' }}.
    Any changes made after that point will be overwritten.
  </p>
  <div class="confirm-actions">
    <button type="button" class="btn btn-secondary" (click)="cancelRevert()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirmRevert()">
      <i class="fas fa-undo"></i> Yes, Revert
    </button>
  </div>
</div>
</div> -->
